import "./App.less";

import AppLayout from "./Pages/appLayout";

const App: React.FC = () => {
  return <AppLayout />;
};

export default App;
